import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { editStaffInfo } from "../../../features/staff/staffSlice";
import { AuthRole } from "../../../utils/roles";
import AppButton from "../../common/AppButton";
import AppErrorMessage from "../../common/AppErrorMessage";
import AppFileInput from "../../common/AppFileInput";
import LoadingSpinner from "../../common/Loading";
import GlobalPhoneEditInput from "../../common/GlobalPhooneInput";

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getProfileData: () => void;
  profileInfo: any;
  clinicId: string;
  queryId: any;
}
const EditInfoModal = ({
  handleClose,
  setOpenSnackbar,
  getProfileData,
  profileInfo,
  clinicId,
  queryId,
}: IProps) => {
  const doctor_name = profileInfo?.name?.split(" ");
  const { role }: any = AuthRole();
  const [formState, setFormState] = useState({
    name:
      doctor_name && doctor_name.length >= 2
        ? doctor_name[doctor_name.length - 2]
        : "",
    lastname:
      doctor_name && doctor_name.length >= 1
        ? doctor_name[doctor_name.length - 1]
        : "",
    email: profileInfo?.email,
    phone_number: profileInfo?.phone_number,
    designation: profileInfo?.designation,
  });

  const [file, setFile] = useState<any>();
  const [phoneError, setPhoneError] = useState("");
  const [feildValue, setfeildValue] = useState("");
  const dispatch = useAppDispatch();
  const { isEditStaffInfoError, isEditStaffInfoLoading, editStaffInfoMessage } =
    useAppSelector((state) => state.staff);

  const handleFileChange = (e: any) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData: any = new FormData();
    formData.append("clinic_id", clinicId);
    formData.append("staff_id", queryId);
    formData.append("name", formState.name + " " + formState.lastname);
    if (formState.email) {
      formData.append("email", formState.email);
    }
    formData.append("phone_number", feildValue);
    formData.append("designation", formState.designation);
    formData.append("profile_picture", file);

    dispatch(editStaffInfo(formData)).then((res) => {
      const existing_auth: any = localStorage.getItem("authToken");
      if (res.payload.success === true) {
        if (role == "staff") {
          const convertJson = JSON.parse(existing_auth);
          convertJson.name = formState.name + " " + formState.lastname;
          localStorage.setItem("authToken", JSON.stringify(convertJson));
        }

        setOpenSnackbar();
        handleClose();
        getProfileData();
      }
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      {isEditStaffInfoLoading ? (
        <LoadingSpinner style={{ minHeight: "40vh" }} />
      ) : (
        <Box
          sx={{
            pt: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              px: 3,
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
              <Box sx={{ width: "50%", pr: 2 }}>
                <Typography variant="h6" gutterBottom>
                  First Name
                </Typography>
                <TextField
                  label="First Name"
                  fullWidth
                  value={formState?.name || ""}
                  onChange={(e: any) =>
                    setFormState({
                      ...formState,
                      name: e.target.value.trim(),
                    })
                  }
                />
              </Box>
              <Box sx={{ width: "50%", pl: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Last Name
                </Typography>
                <TextField
                  label="Last Name"
                  fullWidth
                  value={formState?.lastname || ""}
                  onChange={(e: any) =>
                    setFormState({
                      ...formState,
                      lastname: e.target.value.trim(),
                    })
                  }
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                mt: 3,
              }}
            >
              <Box sx={{ width: "50%", pr: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Contact
                </Typography>
                <GlobalPhoneEditInput
                  value={formState?.phone_number || ""}
                  setfeildValue={setfeildValue}
                />
              </Box>
              <Box sx={{ width: "50%", pl: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Email
                </Typography>
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  value={formState?.email || ""}
                  onChange={(e: any) =>
                    setFormState({
                      ...formState,
                      email: e.target.value,
                    })
                  }
                />
              </Box>
            </Box>
            <Box sx={{ width: "100%", mt: 3 }}>
              {phoneError && <AppErrorMessage message={phoneError} />}
            </Box>

            <Box sx={{ width: "48%" }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>
              <TextField
                label="Designation"
                fullWidth
                onChange={(e: any) =>
                  setFormState({
                    ...formState,
                    designation: e.target.value,
                  })
                }
                value={formState?.designation || ""}
              />
            </Box>

            <Box sx={{ width: "100%", mt: 3 }}>
              {isEditStaffInfoError && (
                <AppErrorMessage message={editStaffInfoMessage} />
              )}
            </Box>
          </Box>

          <Box sx={{ width: "100%", mt: 3 }}>
            <AppButton
              title="Update"
              style={{ float: "right", margin: "10px" }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EditInfoModal;
